const en = {
  heading: 'UX Core',
  link: 'uxcore.io',
  description:
    'The biggest free library of cognitive biases (thinking patterns) with over a thousand use cases',
  moto: 'Be Kind. Do Good.',
  mainTitle: 'Bias environment',
  browsingAsProduct: 'You are viewing Product Management use cases',
  browsingAsHR: 'You are viewing People Management use cases',
  browsingAsOffsec: 'You are viewing offensive security use cases',
  sectionTitles: [
    { color: 'purple', title: 'What should we remember?' },
    { color: 'pink', title: 'Need to act fast' },
    { color: 'green', title: 'Not enough meaning' },
    { color: 'blue', title: 'Too much information' },
  ],
  legends: ['Product value', 'Management value'],
  explanationLink: {
    title: 'This tool explained',
    link: 'https://keepsimple.io/articles/what-is-ux-core',
  },
};

export default en;
